<template>
  <div class="photoTrap">
    <LoadingPlaceholder v-if="preparing == true" />

    <template v-if="groupedPhotos && groupedPhotos.length > 0">
      <div
        id="nav-tab"
        class="nav nav-tabs"
        role="tablist"
      >
        <a
          v-for="(gp, index) in groupedPhotos"
          :id="`spoT${index}-tab`"
          :key="`Phototrap-tab-listItem-${index}`"
          :class="['nav-item nav-link', { active: index == 0 }]"
          data-toggle="tab"
          :href="`#spoT${index}`"
          role="tab"
          :aria-controls="`spoT${index}`"
          :aria-selected="index === 0"
        >Name: {{ gp.camName }}, Spot: {{ gp.spotId }}</a>
      </div>
      <div
        id="nav-tabContent"
        class="tab-content"
      >
        <div
          v-for="(vals, index) in groupedPhotos"
          :id="`spoT${index}`"
          :key="`Phototrap-session-listItem-${index}`"
          :class="['tab-pane fade show', { active: index == 0 }]"
          role="tabpanel"
          :aria-labelledby="`spoT${index}-tab`"
        >
          <SessionOverview
            :runs="vals.items"
            :display-properties="['createDate', 'card']"
            :loading="loading"
            :filter="filter"
            :installation-type="installationType"
            :installation-id="installationId"
            @loadSessions="loadSessions"
          />
        </div>
      </div>
    </template>

    <p
      v-else-if="
        preparing == false &&
          (groupedPhotos == null || groupedPhotos.length == 0)
      "
    >
      No data available.
    </p>

    <SweetModal
      :id="modalId"
      ref="photoStartmodal"
      title="Session"
      width="75%"
      @closeModal="closeModal"
    >
      <template slot="box-action">
        <toggle-button
          v-model="viewDecoratedPhotos"
          :labels="{ checked: 'decorated', unchecked: 'normal' }"
          :width="100"
          :height="30"
          :font-size="12"
          class="mr-3 mt-2"
        />
      </template>
      <sweet-modal-tab
        id="tab1"
        title="Photo"
      >
        <LoadingPlaceholder v-if="itemLoading" />
        <template v-else>
          <img
            v-if="altImageAvailable"
            id="img"
            :src="altImageUrl"
            class="img-fluid"
          />
          <ImagePlaceholderSvg
            v-else
            class="img-fluid"
          />
        </template>
      </sweet-modal-tab>

      <sweet-modal-tab
        id="tab2"
        title="Details"
      >
        <table
          v-if="phototrap != null"
          class="defaultTable"
        >
          <colgroup>
            <col width="200" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>Id</th>
              <td class="lineBreaks">
                {{ phototrap.id }}
              </td>
            </tr>
            <tr>
              <th>Card Number</th>
              <td class="lineBreaks">
                {{ phototrap.cardId ? phototrap.cardId.id : "" }}
              </td>
            </tr>
            <tr>
              <th>Create date</th>
              <td v-tooltip="dateTime_fromNow(phototrap.startTime)">
                {{ dateTime_dateTime(phototrap.startTime) }}
              </td>
            </tr>
            <tr>
              <th>Image Url</th>
              <td>
                {{
                  phototrap.media && phototrap.media.hd
                    ? phototrap.media.hd.url
                    : ""
                }}
              </td>
            </tr>
            <tr>
              <th>Snapshot Url</th>
              <td>
                {{
                  phototrap.media && phototrap.media.preview
                    ? phototrap.media.preview.url
                    : ""
                }}
              </td>
            </tr>
            <tr>
              <th>Point Id</th>
              <td>{{ phototrap.pointId }}</td>
            </tr>
            <tr>
              <th>External Ids</th>
              <td class="lineBreaks">
                <template v-if="phototrap.externalIds && phototrap.externalIds.length > 0">
                  <div
                    v-for="(externalId, index) in phototrap.externalIds"
                    :key="`phototrap-externalId-${ index }`"
                  >
                    {{ externalId.type }}: {{ externalId.number }}
                  </div>
                </template>
                <template v-else>
                  {{ $t("noDataAvailable") }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </sweet-modal-tab>
      <sweet-modal-tab
        id="tab3"
        title="EXIF"
      >
        <pre v-if="exifData">{{ exifData }}</pre>
        <template v-else>
          {{ $t("noDataAvailable") }}
        </template>
      </sweet-modal-tab>
    </SweetModal>
  </div>
</template>

<script>
import { dateTimeMixin } from "@/mixins/dateTimeMixin.js";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";

export default {
  name: "PhotoTrap",
  components: {
    ImagePlaceholderSvg: () =>
      import("@/components/Base/ImagePlaceholderSvg.vue"),
    SessionOverview: () => import("@/components/Media/SessionOverview.vue"),
    SweetModal,
    SweetModalTab,
  },
  mixins: [dateTimeMixin],
  props: {
    installationId: {
      type: String,
      required: true,
    },
    installationType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      useAlternativeFilter: true,
      loading: true,
      groupedPhotos: null,
      altImageUrl: "",
      modalId: "photostartModal",
      filter: {
        dates: null,
        cardNumber: null,
        startDate: null,
        endDate: null,
        showIncomplete: true,
        limit: 100,
      },
      preparing: true,
      payload: null,
      phototrap: null,
      viewDecoratedPhotos: true,
      exifData: null,
      itemLoading: false
    };
  },
  computed: {
    areTherePhotos: function () {
      if (this.groupedPhotos && this.groupedPhotos.length > 0) return true;
      return false;
    },
    altImageAvailable: function () {
      if (
        !this.itemLoading && ((this.getDecoratedImageUrl(this.payload)) ||
        (this.phototrap &&
          this.phototrap.media &&
          this.phototrap.media.hd &&
          this.phototrap.media.hd.url))
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    viewDecoratedPhotos(val) {
      if (this.altImageAvailable) {
        this.altImageUrl = val
          ? this.getDecoratedImageUrl(this.payload) || this.getStandardImageUrl(this.phototrap)
          : this.phototrap &&
            this.phototrap.media &&
            this.phototrap.media.hd &&
            this.phototrap.media.hd.url
          ? this.phototrap.media.hd.url
          : this.getDecoratedImageUrl(this.payload);
      }
    },
  },
  created() {
    let tmpDate = new Date(Date.now());
    this.filter.startDate = new Date(
      tmpDate.getFullYear(),
      tmpDate.getMonth(),
      tmpDate.getDate() - 1,
      0,
      0,
      0
    );
    this.filter.endDate = new Date(
      tmpDate.getFullYear(),
      tmpDate.getMonth(),
      tmpDate.getDate(),
      23,
      59,
      59
    );
    this.filter.dates = [];
    this.filter.dates.push(this.filter.startDate, this.filter.endDate);

    this.loadSessions();
    this.$eventBus.$on(`openModal${this.modalId}`, this.openModal);
  },
  beforeDestroy() {
    this.$eventBus.$off(`openModal${this.modalId}`, this.openModal);
  },
  methods: {
    getDecoratedImageUrl(payload) {
      if (!payload) {
        return null;
      }

      return payload.decoratedUrl || payload.brandedImageUrl || null;
    },
    getStandardImageUrl(payload) {
      if (!payload) {
        return null;
      }

      if (payload.media && payload.media.hd && payload.media.hd.url) {
        return payload.media.hd.url;
      }

      return payload.url || payload.imageUrl || null;
    },
    getItem(id) {
      this.itemLoading = true;
      this.axios
        .get(`/Media/GetItem/${id}`)
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          this.phototrap = response.data;
          this.getExifData(this.phototrap);
          if (this.viewDecoratedPhotos) {
            this.altImageUrl = this.getDecoratedImageUrl(this.payload) || this.getStandardImageUrl(this.phototrap);
          } else {
            this.altImageUrl = this.getStandardImageUrl(this.phototrap);
          }
        })
        .finally(() => {
          this.itemLoading = false;
        });
    },
    openModal(payload) {
      this.payload = payload;
      if (this.isChinaInstallation) {
        this.viewDecoratedPhotos = false;
      }
      this.getItem(payload.id);
      this.$refs.photoStartmodal.open();
    },
    closeModal() {
      this.payload = null;
      this.phototrap = null;
      this.altImageUrl = "";
      this.exifData = null;
      this.$refs.photoStartmodal.close();
    },
    // GET DEVICE gets the data for the device specified by the deviceId
    loadSessions(payload) {
      if (payload == null || this.useAlternativeFilter == true) {
        payload = {
          limit: 100,
          dates: [
            this.useAlternativeFilter == true ? null : this.filter.startDate,
            this.useAlternativeFilter == true ? null : this.filter.endDate,
          ],
        };
      }
      this.loading = true;
      const reqObj = {
        installationId: this.installationId,
        startDate: this.dateTime_isoString(payload.dates[0]),
        endDate: this.dateTime_isoString(payload.dates[1]),
        limit: payload.limit
      }
      this.axios
        .post(
          `/Media/GetPhototrapMedia`, reqObj
        )
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          if (response.data.length === 0) {
            return;
          }
          this.groupedPhotos = response.data;
        })
        .finally(() => {
          this.loading = false;
          window.setTimeout(() => {
            this.preparing = false;
          }, 500);
        });
    },
    getExifData(payload) {
      if (payload.media && payload.media.hd && payload.media.hd.url) {
        var urlObj = {
          url: payload.media.hd.url,
        };

        this.axios.post(`/Media/GetExifData`, urlObj).then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          this.exifData = JSON.stringify(JSON.parse(response.data), null, 2);
        });
      }
    },
  },
};
</script>
